import { useQuery, UseQueryOptions } from 'react-query';

import { LenderDeclineReason, Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useLenderDeclineReasonsQuery(
	options?:
		| Omit<UseQueryOptions<LenderDeclineReason[], unknown, LenderDeclineReason[], any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Lookups.LenderDeclineReasons,
		() =>
			AxiosUtils.getResponseData<LenderDeclineReason[]>(
				api.get(CerebroApiEndpoints.Lookups.LenderDeclineReasons)
			),
		options
	);
}
